import { useTranslation } from 'react-i18next'
import { useAdminBillingInvoices } from '../../hooks/use-admin-billing'
import { BillingInvoicesTable } from './BillingInvoicesTable'

/** BillingInvoicesSection lists the invoices of one organization (spec 2026-10-05-14). */
export function BillingInvoicesSection({ orgUid }: { orgUid: string }) {
  const { t } = useTranslation('admin')
  const { data, isLoading } = useAdminBillingInvoices({ organization_uid: orgUid })
  const rows = data?.data ?? []
  return (
    <section className="space-y-4" data-testid="billing-org-invoices">
      <div>
        <h2 className="text-lg font-semibold">{t('billing.invoices.org_title')}</h2>
        <p className="text-sm text-muted-foreground">{t('billing.invoices.org_help')}</p>
      </div>
      <div className="bg-card rounded-lg border border-border overflow-hidden">
        {isLoading ? (
          <div className="px-6 py-4 text-center text-muted-foreground">{t('billing.loading')}</div>
        ) : rows.length === 0 ? (
          <div className="px-6 py-4 text-center text-muted-foreground" data-testid="billing-org-invoices-empty">
            {t('billing.invoices.empty')}
          </div>
        ) : (
          <BillingInvoicesTable invoices={rows} />
        )}
      </div>
    </section>
  )
}
